import _asyncToGenerator from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './ItineraryDayViewHeader.css';
import React from 'react';
import { get, canUseDOM } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
// import GoogleMap, { defaultMapState, googleMapDirectionLink } from '../atoms/GoogleMaps/GoogleMaps';
import { getPlaceInfoByIDPromise } from '../atoms/GoogleMaps/GooglePlaceService';
// import OSM from '../atoms/OpenStreetMap/OpenStreetMap';

import loadable from '@loadable/component';
var OSM = loadable(function () {
  return import('../atoms/OpenStreetMap/OpenStreetMap');
}, {
  ssr: false
});
var staticMap = 'https://maps.googleapis.com/maps/api/staticmap';
var markerUrl = '/dist/inventory/assets/images/marker.png';
export var ItineraryDayViewHeader = function ItineraryDayViewHeader(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var currentLang = get(sitecoreContext, 'language');
  var googleApiKey = get(sitecoreContext, 'configuration.google.apiKey', '');
  /* const newWindowLabel: string = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window"; */
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  var mapDictionary = dictionaryValues.reduce(function (map, currentValue) {
    return map.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  var ColorHex = '#525252';
  /* const ActiveColorHex = get(params, 'ActiveColorHex', '--main-color--active'); */
  var ActiveColorHex = get(params, 'BackgroundColorHex', '--main-color');
  var activeItemID = get(fields, 'data.item.activeItemId');
  var daysItems = get(fields, 'data.item.days.values');
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    currentItem = _React$useState2[0],
    setCurrentItem = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    title = _React$useState4[0],
    setTitle = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    locationsCount = _React$useState6[0],
    setLocationsCount = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    mapApiReady = _React$useState8[0],
    setMapApiReady = _React$useState8[1];
  var _React$useState9 = React.useState(),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isChina = _React$useState10[0],
    setIsChina = _React$useState10[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    GoogleMap = _React$useState12[0],
    setGoogleMap = _React$useState12[1];
  var _React$useState13 = React.useState(''),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    googleMapImg = _React$useState14[0],
    setGoogleMapImg = _React$useState14[1];
  var _React$useState15 = React.useState([]),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    markersMap = _React$useState16[0],
    setMarkersMap = _React$useState16[1];
  var _React$useState17 = React.useState({
      lat: 25.2048493,
      lng: 55.2707828,
      activeMarker: 0,
      markers: [{}],
      vis: false
    }),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    mapState = _React$useState18[0],
    setMapState = _React$useState18[1];
  React.useEffect(function () {
    var urlParams = new URLSearchParams(document.location.search);
    var isC = Boolean(urlParams.get('isChina') === 'true');
    setIsChina(isC);
    if (daysItems) {
      daysItems.map(function (item) {
        if (activeItemID === item.id) {
          setCurrentItem(item);
          setMarkersMap(item.pois.values);
          setTitle(item.title.jss.value);
          setLocationsCount(item.pois.values.length);
          updateLocations(item);
        }
      });
    }
  }, [mapApiReady]);
  var placeInfoRef = React.useRef(null);
  var updateLocations = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(item) {
      var markersPromArr;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (item) {
              markersPromArr = item.pois.values.map(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(item) {
                  var title, googlePlaceId, lat, lng, place;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        title = get(item, 'title.jss.value');
                        googlePlaceId = get(item, 'googlePlaceID.jss.value');
                        lat = get(item, 'latitude.jss.value');
                        lng = get(item, 'longitude.jss.value');
                        if (!(!isChina && googlePlaceId && mapApiReady)) {
                          _context.next = 10;
                          break;
                        }
                        _context.next = 7;
                        return getPlaceInfoByIDPromise(googlePlaceId, placeInfoRef.current);
                      case 7:
                        place = _context.sent;
                        lng = place && place.geometry && place.geometry.location && place.geometry.location.lng();
                        lat = place && place.geometry && place.geometry.location && place.geometry.location.lat();
                      case 10:
                        return _context.abrupt("return", {
                          lng: lng,
                          lat: lat,
                          title: title
                        });
                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());
              Promise.all(markersPromArr).then(function (markers) {
                // default map center is first valid marker in array
                var _markers$find = markers.find(function (_ref4) {
                    var lat = _ref4.lat,
                      lng = _ref4.lng;
                    return lat && lng;
                  }),
                  lat = _markers$find.lat,
                  lng = _markers$find.lng;
                setMapState(_objectSpread(_objectSpread({}, mapState), {}, {
                  vis: true,
                  activeMarker: 0,
                  lat: lat,
                  lng: lng,
                  markers: markers
                }));
              });
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function updateLocations(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var apiReady = function apiReady() {
    setTimeout(function () {
      setMapApiReady(true);
    }, 2000);
  };
  var markerCallback = function markerCallback() {};
  React.useEffect(function () {
    setTimeout(function () {
      setGoogleMap(loadable(function () {
        return import('../atoms/GoogleMaps/GoogleMaps');
      }, {
        ssr: false
      }));
    }, 2000);
  }, []);
  var loc = canUseDOM ? window.location.host : '';
  React.useEffect(function () {
    console.log("icon:".concat('http://' + loc + markerUrl));
    // const markers = markersMap.reduce((accumulator: string, marker: any) =>
    //     `${accumulator}&markers=icon:${'http://' + loc + markerUrl}%7C${marker.latitude.jss.value},${marker.longitude.jss.value}`
    //     , '');
    // setGoogleMapImg(`${staticMap}?language=en&center=${mapState.lat},${mapState.lng}&zoom=10&size=1180x590${markers}&key=${googleApiKey}`);
  }, [markersMap, mapState.lat, mapState.lng]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group remove-padding-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row d-md-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__title h2"
  }, title))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-10 offset-xl-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__map-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__map-wrapper-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__map"
  }, /*#__PURE__*/React.createElement("div", {
    ref: placeInfoRef,
    id: "place-info"
  }), /*#__PURE__*/React.createElement("div", {
    className: "header-mv__map_block ".concat(mapApiReady ? 'visible' : 'invisible')
  }, !isChina && GoogleMap && /*#__PURE__*/React.createElement(GoogleMap, {
    language: currentLang,
    mapKey: googleApiKey,
    disableBound: true,
    zoom: 10,
    callback: apiReady,
    mapState: mapState,
    theme: _objectSpread(_objectSpread({}, get(sitecoreContext, 'themesOfPage')), {
      primary: mapState.markers.length > 1 ? ColorHex : ActiveColorHex,
      primary_active: ActiveColorHex
    })
  })), !mapApiReady && googleMapImg && /*#__PURE__*/React.createElement("img", {
    src: googleMapImg,
    className: "map-img visible",
    alt: ""
  }), isChina && /*#__PURE__*/React.createElement(OSM, {
    zoom: 9,
    customMarker: false,
    callback: apiReady,
    markerCallback: markerCallback,
    mapState: mapState
  })), /*#__PURE__*/React.createElement("div", {
    className: "header-mv__controls"
  }, /*#__PURE__*/React.createElement("span", {
    className: "my-icon-white header-mv__controls-btn"
    //target="_blank"
    //rel="noopener noreferrer"
    //aria-label={`${title} | ${newWindowLabel}`}
    //   href={googleMapDirectionLink(mapState.lat, mapState.lng)}
  }, /*#__PURE__*/React.createElement("svg", {
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "21",
    viewBox: "0 0 22 21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--main-color)",
    fillRule: "nonzero",
    d: "M9.707 0a2 2 0 0 0 0 2.828l.879.879H3c-1.654 0-3 1.346-3 3v6h2v-6c0-.551.449-1 1-1h7.586l-.879.879a2 2 0 0 0 0 2.828l4.707-4.707L9.707 0z",
    transform: "translate(4 2)"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "header-mv__overlay"
  }, title && /*#__PURE__*/React.createElement("h1", {
    className: "d-none d-md-block header-mv__title h2"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "header-mv__labels-sec"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__labels-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__label"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__label-icon"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16.093",
    height: "19.71",
    viewBox: "0 0 16.093 19.71"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-76.508 -194.206)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57",
    transform: "translate(76.758 193.961)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 107",
    d: "M84.4,193.964a7.6,7.6,0,0,0-7.639,7.2v.038c.125,4.366,3.95,8.393,7.335,11.755a.754.754,0,0,0,1.062-.019c3.132-3.372,7.275-7.026,7.195-11.943v0a7.555,7.555,0,0,0-7.954-7.033Zm.026,1.3a6.155,6.155,0,0,1,6.509,5.763C91,205,87.67,208.253,84.617,211.492c-3.168-3.2-6.32-6.842-6.43-10.3a6.178,6.178,0,0,1,6.236-5.93Z",
    transform: "translate(-76.758 -193.466)",
    fill: "var(--main-color)",
    stroke: "var(--main-color)",
    "stroke-width": "0.5"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 78",
    cx: "2",
    cy: "2",
    r: "2",
    transform: "translate(6 6)",
    fill: "var(--main-color)"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "header-mv__label-text"
  }, locationsCount, " ", mapDictionary.get('Places'))))))))))))))))));
};
var StyledWrapper = function StyledWrapper(_ref5) {
  var children = _ref5.children,
    rtl = _ref5.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(headerCommonStyle, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var headerCommonStyle = "h1fy3op8";
var ltrStyles = "le85g9k";
var rtlStyles = "r1eg9nxl";
export default ItineraryDayViewHeader;